import { StateCreator } from "zustand";

export interface SystemSlice {
  saleOptionEditorOpenZustand: boolean;
  setSaleOptionEditorOpenedZustand: (
    saleOptionEditorOpenZustand: boolean
  ) => void;
}

export const createSystemSlice: StateCreator<SystemSlice> = (set, get) => ({
  saleOptionEditorOpenZustand: false,
  setSaleOptionEditorOpenedZustand: (saleOptionEditorOpenZustand: boolean) =>
    set((state) => ({
      saleOptionEditorOpenZustand: saleOptionEditorOpenZustand,
    })),
});
